import {
  Component,
  OnInit,
  ViewChild,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { MatSidenav } from '@angular/material';
import { Router, NavigationEnd } from '@angular/router';
import { AgentProfileService } from '../../../services/agent-profile.service';
import * as moment from 'moment';
import { Broadcaster } from '../../../services/broadcaster.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  @Input() notificPanel;
  @Input() notificationsData;
  @Output() notificationsCount = new EventEmitter();
  agentEventsSub: Subscription;

  // Dummy notifications
  notifications = [];

  constructor(
    private router: Router,
    private agentInfoService: AgentProfileService,
    public broadcaster: Broadcaster,
  ) {}

  ngOnInit() {
    if (!this.agentInfoService.readyAgentEvents) {
      this.agentEventsSub = this.agentInfoService.agentEvents.subscribe(
        data => {
          this.notificationsData = data;
          this.notifications = [];
          if (data && data.list.length > 0) {
            for (var i = 0; i < data.list.length; i++) {
              if (data.list[i].eventType === 'manual_lead_upload') {
                this.notifications.push({
                  message: data.list[i].eventMessage,
                  icon: 'person_add',
                  route:
                    '/lead/' +
                    data.list[i].details.leadProvider.toLowerCase() +
                    '/' +
                    this.notificationsData.list[i].details.leadId +
                    '/profile',
                  color: 'primary',
                  notificationId: data.list[i]._id,
                  time: data.list[i].created_at
                    ? moment(data.list[i].created_at).format('MMM D')
                    : '',
                });
              } else if (data.list[i].eventType === 'new_lead_meeting') {
                this.notifications.push({
                  message: data.list[i].eventMessage,
                  icon: 'event',
                  route:
                    '/lead/' +
                    data.list[i].details.leadProvider.toLowerCase() +
                    '/' +
                    this.notificationsData.list[i].details.leadId +
                    '/profile',
                  color: 'primary',
                  notificationId: data.list[i]._id,
                  time: data.list[i].created_at
                    ? moment(data.list[i].created_at).format('MMM D')
                    : '',
                });
              } else if (data.list[i].eventType === 'upload_csv') {
                this.notifications.push({
                  message: data.list[i].eventMessage,
                  icon: 'group_add',
                  route: '/contacts',
                  color: 'primary',
                  notificationId: data.list[i]._id,
                  time: data.list[i].created_at
                    ? moment(data.list[i].created_at).format('MMM D')
                    : '',
                });
              } else if (data.list[i].eventType === 'owner_list_sample') {
                this.notifications.push({
                  message: data.list[i].eventMessage,
                  icon: 'event',
                  route: '/contacts',
                  color: 'primary',
                  notificationId: data.list[i]._id,
                  time: data.list[i].created_at
                    ? moment(data.list[i].created_at).format('MMM D')
                    : '',
                  data: data.list[i].details,
                });
              }
            }
          }
          this.notifications.push({
            message: 'Welcome to your dashboard! Need help navigating?',
            icon: 'dashboard',
            color: 'primary',
            route: '/',
          });
          this.notificationsCount.emit(this.notifications.length);
        },
      );
    } else {
      this.notificationsData = this.agentInfoService.agentEvents;
      if (
        this.notificationsData &&
        this.notificationsData.list &&
        this.notificationsData.list.length > 0
      ) {
        for (var i = 0; i < this.notificationsData.list.length; i++) {
          if (
            (this.notificationsData.list[i].eventType = 'manual_lead_upload')
          ) {
            this.notifications.push({
              message: this.notificationsData.list[i].eventMessage,
              icon: 'person_add',
              route:
                '/lead/' +
                this.notificationsData.list[
                  i
                ].details.leadProvider.toLowerCase() +
                '/' +
                this.notificationsData.list[i].details.leadId +
                '/profile',
              color: 'primary',
              notificationId: this.notificationsData.list[i]._id,
              time: this.notificationsData.list[i].list[i].created_at
                ? moment(
                    this.notificationsData.list[i].list[i].created_at,
                  ).format('MMM D')
                : '',
            });
          } else if (
            (this.notificationsData.list[i].eventType = 'new_lead_meeting')
          ) {
            this.notifications.push({
              message: this.notificationsData.list[i].eventMessage,
              icon: 'event',
              route:
                '/lead/' +
                this.notificationsData.list[
                  i
                ].details.leadProvider.toLowerCase() +
                '/' +
                this.notificationsData.list[i].details.leadId +
                '/profile',
              color: 'primary',
              notificationId: this.notificationsData.list[i]._id,
              time: this.notificationsData.list[i].list[i].created_at
                ? moment(
                    this.notificationsData.list[i].list[i].created_at,
                  ).format('MMM D')
                : '',
            });
          } else if (
            (this.notificationsData.list[i].eventType = 'upload_csv')
          ) {
            this.notifications.push({
              message: this.notificationsData.list[i].eventMessage,
              icon: 'group_add',
              route: '/contacts',
              color: 'primary',
              notificationId: this.notificationsData.list[i]._id,
              time: this.notificationsData.list[i].list[i].created_at
                ? moment(
                    this.notificationsData.list[i].list[i].created_at,
                  ).format('MMM D')
                : '',
            });
          } else if (
            this.notificationsData.list[i].eventType === 'owner_list_sample'
          ) {
            this.notifications.push({
              message: this.notificationsData.list[i].eventMessage,
              icon: 'event',
              route: '/contacts',
              color: 'primary',
              notificationId: this.notificationsData.list[i]._id,
              time: this.notificationsData.list[i].created_at
                ? moment(this.notificationsData.list[i].created_at).format(
                    'MMM D',
                  )
                : '',
              data: this.notificationsData.list[i].details,
            });
          }
        }
      }
      this.notifications.push({
        message: 'Welcome to your dashboard! Need help navigating?',
        icon: 'dashboard',
        color: 'primary',
        route: '/contacts',
      });
      this.notificationsCount.emit(this.notifications.length);
    }
  }

  ngOnDestroy() {
    if (this.agentEventsSub) this.agentEventsSub.unsubscribe();
  }

  clearNotification(value, route?, ownersListData?) {
    if (ownersListData) {
      this.broadcaster.setOwnersListData(ownersListData);
    }
    if (value != 'all') {
      if (!ownersListData) {
        var postBody = {
          idSet: [value.notificationId],
        };
        this.agentInfoService.deleteAgentEvent(postBody).subscribe(data => {
          if (data.status == 'success') {
            var objectToRemove = this.notifications.findIndex(
              x => x.notificationId == value.notificationId,
            );
            this.notifications.splice(objectToRemove, 1);
            this.notificationsCount.emit(this.notifications.length);
          }
        });
        this.notificPanel.toggle();
      }
    } else {
      var idSet = [];
      for (var i = 0; i < this.notifications.length; i++) {
        idSet.push(this.notifications[i].notificationId);
      }
      var postBody = {
        idSet: idSet,
      };
      this.agentInfoService.deleteAgentEvent(postBody).subscribe(data => {
        if (data.status == 'success') {
          this.notifications = [];
          this.notificationsCount.emit(this.notifications.length);
        }
      });
      this.notificPanel.toggle();
    }
    if (route) {
      setTimeout(() => {
        this.router.navigate([route]);
      }, 300);
    }
  }
}
